// extracted by mini-css-extract-plugin
export default {"button":"SwapSelectToken_button__ufrsw","logo":"SwapSelectToken_logo__uhViP","name":"SwapSelectToken_name__I+tLn","icon":"SwapSelectToken_icon__hp+wW"};